export const LAYOUT_CONSTANTS = {
  DRAWER_WIDTH_OPEN: 195,
  DRAWER_WIDTH_CLOSE: 73,
  TOP_BAR_HEIGHT: 110,
  MOBILE_HEADER_HEIGHT: 80,
  CONTENT_PADDING: 40,
};
